import { init } from './errorTracking';

init();

window.__currentRev__ = __currentRev__;
